module.exports = __webpack_public_path__ + "static/google-play-image-115ae59e23b0eb6927dec456d452bf27.png";